// extracted by mini-css-extract-plugin
export default {"modalH2":"ModalSettings_modalH2__Ro5zF","inputMarginBottom":"ModalSettings_inputMarginBottom__u9EiR"};